// eslint-disable-next-line import/no-anonymous-default-export
export default {
    apiKey: "AIzaSyDHLFIgy2KpAH89hpYFhQq36GSdym4gn40",
    authDomain: "github-finder-9f607.firebaseapp.com",
    projectId: "github-finder-9f607",
    storageBucket: "github-finder-9f607.appspot.com",
    messagingSenderId: "790528034079",
    appId: "1:790528034079:web:08aeb3e57acfd8a0789c2a",
    measurementId: "G-458M15CSV2"
  };